import React from "react";
import { Modal } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroller";

import { getOwnerCars, removeCar, getCarSetting } from "../../model/car";

import { commonErr } from "../common/errors";
import { LoadingPage, LoadingInline } from "../common/loading";
import { Empty, MessageBox } from "../common/messagebox";

import Header from "../components/header";
import Session from "../common/session";

import OwnerSidebar from "../carowner/components/ownersidebar";
import Balance from "../carowner/components/balance";
import CarItemMyCars from "../common/caritemmycars";

import empty from "../../static/images/empty/empty-mycar.svg";

class MyCars extends React.Component {
	constructor() {
		super();
		this.state = {
			cars: [],
			err: commonErr.INNIT,
			errMsg: "",
			isShowConfirmRemove: false,
			activeCarId: 0,
			filterStatus: 0,
			cancelReasons: null,
			ip_cancel_reason: "t0",
			ip_comment: "",
			showMessageBox: false,
			isSmallMenu: false,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		this.setState({
			err: commonErr.LOADING,
		});

		getOwnerCars(0, 0, 0, 0, true).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.cars) {
				this.setState({
					cars: resp.data.data.cars,
					more: resp.data.data.more * 1,
					err: resp.data.error,
				});
			} else {
				this.setState({
					err: resp.data.error,
				});
			}
		});
	}

	getOwnerCarsMore = () => {
		const nextPos = this.state.cars.length;
		getOwnerCars(0, 0, nextPos, 0).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.cars) {
				this.setState({
					cars: this.state.cars.concat(resp.data.data.cars),
					more: resp.data.data.more * 1,
					err: resp.data.error,
				});
			} else {
				this.setState({
					err: resp.data.error,
				});
			}
		});
	};

	showConfirmRemove = (carId) => {
		getCarSetting({ carId: carId }).then((carSettingResp) => {
			if (carSettingResp.data.error >= commonErr.SUCCESS) {
				this.setState({
					removeReason: carSettingResp.data.data.removeReason,
				});
			} else {
				this.setState({
					err: carSettingResp.data.error,
				});
			}
		});

		this.setState({
			isShowConfirmRemove: true,
			activeCarId: carId,
		});
	};

	hideConfirmRemove = () => {
		this.setState({
			isShowConfirmRemove: false,
			activeCarId: 0,
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	removeCar = () => {
		if (!this.isValidRemoveCar()) {
			this.showMessageBox();
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng chọn lý do hoặc ghi rõ lý do của bạn.",
			});
			return;
		}

		const { activeCarId, ip_cancel_reason, ip_comment } = this.state;

		this.setState({
			err: commonErr.LOADING,
		});

		removeCar(activeCarId, ip_cancel_reason, ip_comment).then((resp) => {
			this.hideConfirmRemove();
			if (resp.data.error >= commonErr.SUCCESS) {
				getOwnerCars(0, 0, 0, 0).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS && resp.data.data.cars) {
						this.setState({
							cars: resp.data.data.cars,
							more: resp.data.data.more * 1,
							err: resp.data.error,
						});
					} else {
						this.setState({
							err: resp.data.error,
						});
					}
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	onFilterStatusChange = (event) => {
		this.setState({
			filterStatus: event.target.value * 1,
		});
	};

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	isValidRemoveCar = () => {
		if (!this.state.ip_cancel_reason || this.state.ip_cancel_reason === "" || this.state.ip_cancel_reason === "0") {
			return false;
		}
		if (this.state.ip_cancel_reason === "t0" && (!this.state.ip_comment || this.state.ip_comment === "")) {
			return false;
		}
		return true;
	};

	showMessageBox = () => {
		this.setState({
			showMessageBox: true,
		});
	};

	hideMessageBox = () => {
		this.setState({
			showMessageBox: false,
		});
	};

	toggleMenu = () => {
		this.setState({
			isSmallMenu: !this.state.isSmallMenu,
		});
	};

	render() {
		var propertiesCont;
		const { removeReason, isSmallMenu } = this.state;
		if (this.state.err === commonErr.LOADING) {
			propertiesCont = <LoadingPage />;
		} else {
			var properties = this.state.cars.slice();
			if (properties) {
				if (this.state.filterStatus !== 0) {
					properties = properties.filter((car) => {
						return car.status === this.state.filterStatus;
					});
				}
				if (properties.length > 0) {
					propertiesCont = (
						<InfiniteScroll
							pageStart={0}
							loadMore={this.getOwnerCarsMore}
							hasMore={this.state.more === 1}
							loader={
								<ul>
									<LoadingInline />
								</ul>
							}>
							<div className="list-car">
								{properties.map((car) => (
									<CarItemMyCars key={car.id} car={car} id={car.id} showConfirmRemove={this.showConfirmRemove} />
								))}
							</div>
						</InfiniteScroll>
					);
				} else {
					propertiesCont = <Empty img={empty} msg={"Không tìm thấy xe nào."} />;
				}
			} else {
				propertiesCont = <Empty img={empty} msg={"Không có xe cho thuê"} />;
			}
		}

		return (
			<div className="mioto-layout">
				<Session />
				<Header />
				<section className="body">
					<div className="mycars-section space xl">
						<div className="m-container">
							<div className={`mycars-container ${isSmallMenu ? "more-content" : ""}`}>
								<OwnerSidebar toggleMenu={this.toggleMenu} />
								<div className="content-mycars">
									<Balance />
									<div className="title">
										<h4>Danh sách xe</h4>
										<div className="filter-status">
											<p>Trạng thái: </p>
											<div className="custom-select">
												<select onChange={this.onFilterStatusChange}>
													<option value="0">Tất cả</option>
													<option value="2">Đang hoạt động</option>
													<option value="1">Đang chờ duyệt</option>
													<option value="3">Đã bị từ chối</option>
													<option value="5">Đang tạm ngưng</option>
												</select>
											</div>
										</div>
									</div>
									{propertiesCont}
								</div>
							</div>
						</div>
					</div>
					<Modal
						show={this.state.isShowConfirmRemove}
						onHide={this.hideConfirmRemove}
						dialogClassName="modal- modal-dialog">
						<Modal.Header closeButton={true} closeLabel={""}>
							<h5>Xác nhận xoá xe</h5>
						</Modal.Header>
						<Modal.Body>
							<div className="form-default form-s">
								<div className="line-form">
									<div className="wrap-select">
										<select name="ip_cancel_reason" onChange={this.handleInputChange}>
											{removeReason &&
												removeReason.map((reason) => <option value={reason.reason}>{reason.desc}</option>)}
										</select>
									</div>
								</div>
								<div className="line-form">
									<div className="wrap-input">
										<input
											type="text"
											placeholder="Vui lòng nhập lý do hoặc lời nhắn"
											name="ip_comment"
											onChange={this.handleInputChange}
										/>
									</div>
								</div>

								<div className="clear"></div>
								<div className="space m"></div>
								<p className="textAlign-center has-more-btn">
									<a className="btn btn-primary btn--m" onClick={this.removeCar}>
										Xoá
									</a>
								</p>
							</div>
						</Modal.Body>
					</Modal>
					<MessageBox
						show={this.state.showMessageBox}
						hideModal={this.hideMessageBox}
						message={this.state.errMsg}
						error={this.state.err}
					/>
				</section>
			</div>
		);
	}
}

export default MyCars;
